interface IProps {
  textColor?: string;
}

export default function TrustPilotBanner(props: IProps) {
  return (
    <>
      <div
        className="trustpilot-widget"
        data-locale="en-GB"
        data-template-id="56278e9abfbbba0bdcd568bc"
        data-businessunit-id="6706a745101647bcdbfd7e01"
        data-style-height="52px"
        data-style-width="100%"
        data-token="b7db6fca-1d28-492f-bf79-8d837f4cf55c"
      >
        <a
          href="https://uk.trustpilot.com/review/pense.co.uk"
          target="_blank"
          rel="noreferrer"
        >
          Trustpilot
        </a>
      </div>
      <span
        className={`${props.textColor ? props.textColor : "text-white"} pt-2`}
      ></span>
    </>
  );
}
